module.exports = __webpack_public_path__ + "static/media/unitinfo3.268acea8.gif";